/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import PropTypes from "prop-types";
import OGBox from "assets/theme/components/OGBox";
import { useThemeUIController } from "context";

function DashboardLayout({ children }) {
  const [controller] = useThemeUIController();
  const { collapseSidenav } = controller;

  return (
    <OGBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        pt: 1,
        position: "relative",
        [breakpoints.up("xl")]: {
          marginLeft: collapseSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
    </OGBox>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
